// extracted by mini-css-extract-plugin
export var editInput = "_g3-0";
export var editInputCompact = "_g3-2";
export var editInputLarge = "_g3-1";
export var editInputSmall = "_g3-3";